<template>
  <div class="home-empresa">
    <div class="position-relative">
      <div class="swiper-container carrosellHome">
        <div class="swiper-wrapper">
          <a href="javascript:" class="swiper-slide" v-for="s in slides" :key="s.id_site_destaque" @click="selDestaque(s.site_link)">
            <img class="home-img" :src="s.img_desktop" :alt="s.descricao">
          </a>
        </div>
      </div>
      <div v-if="slides.length > 1" class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
    import Swiper from 'swiper'
    import 'swiper/dist/css/swiper.css'

    export default {
      name: "carrosellHome",
      props: ['slides'],

      methods: {
        selDestaque(link) {
          if (link) {
            if (link.startsWith('http')) {
              window.location.href = link
            } else {
              this.$router.push(link)
            }
          }
        }
      },

      mounted() {
        let swiper = new Swiper('.carrosellHome', {
          slidesPerView: 'auto',
          freeMode: false,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });
      }
    }
</script>

<style scoped>
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-slide {
    width: 100%;
    /*height: 160px;*/
  }
  .swiper-pagination {
    bottom: 12px;
    right: 0;
    left: 0;
    z-index: 0;
  }
  .swiper-pagination >>> .swiper-pagination-bullet {
    opacity: 1;
    border: 1px solid #fff;
    margin: 0 2px;
    background-color: transparent;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active {
    background-color: #fff;
  }
  .home-empresa {
    height: 200px;
    background-color: rgba(0,0,0,0.7);
    overflow: hidden;
    position: relative;
    width: 100%;
    margin: 0 auto;
    border-radius: 0 0 18px 18px;
  }
  .home-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  .theme-2 .home-empresa {
    border-radius: 18px;
    border: 3px solid #ffffff;
  }

  @media (min-width: 768px) {
    .home-empresa {
      border: 3px solid #ffffff;
      border-radius: 18px;
      height: 280px;
    }

    .home-img {
      height: 280px;
    }
  }
</style>
